/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {
    NoteFinderPageBarLineMask_mask$data
} from "ui/feature/root/note-select/__generated__/NoteFinderPageBarLineMask_mask.graphql";
import styles from "./NoteFinderPageBarLineMask.module.scss";

interface Props {
    mask: NoteFinderPageBarLineMask_mask$data;
}

const NoteFinderPageBarLineMask: React.FC<Props> = ({mask}) => {

    const style = {
        WebkitMaskBoxImage: `url(${mask.mask_download_url})`,
    };

    return (
        <div style={style} className={styles.div}/>
    )
}

export default createFragmentContainer(NoteFinderPageBarLineMask, {
    mask: graphql`
    fragment NoteFinderPageBarLineMask_mask on MusicParseStepDataBarLineProcessorMask {
        mask_download_url
    }
    `
});
